import { createContextProvider } from "../../context-provider.js";
import { OmniElement } from "../../omni-element.js";
const OmniContextProvider = createContextProvider();
OmniContextProvider.register = OmniElement.register;
OmniElement.register("omni-context-provider", OmniContextProvider);
export {
  OmniContextProvider
};
//# sourceMappingURL=omni-context-provider.js.map
